var _excluded = ["size", "color", "style", "className", "spin", "rotate"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import * as React from 'react';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FoxIconSwiftCore = function FoxIconSwiftCore(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    role: "img"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M621.504 128.288s198.944 113.728 251.008 294.4c46.912 163.2 9.344 241.088 9.344 241.088a285.312 285.312 0 0 1 55.744 89.6 154.4 154.4 0 0 1 9.28 142.496s-3.2-66.56-102.4-80.352c-90.912-12.8-123.968 75.712-297.6 71.424A589.92 589.92 0 0 1 64 619.392c84.832 46.272 195.968 118.08 334.368 107.072 138.4-11.04 167.296-53.568 167.296-53.568A2140.768 2140.768 0 0 1 156.512 244.64c108.8 91.04 378.304 272.224 372.032 267.616a2426.4 2426.4 0 0 1-269.6-312.512S663.296 532.16 695.84 530.08c13.376-27.552 82.528-170.176-74.368-401.824h0.032z",
      fill: "#F88535"
    })
  }));
};
var Memo = /*#__PURE__*/memo(FoxIconSwiftCore);
/**
 * ![FoxIconSwift](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCI+PHBhdGggZD0iTTYyMS41MDQgMTI4LjI4OHMxOTguOTQ0IDExMy43MjggMjUxLjAwOCAyOTQuNGM0Ni45MTIgMTYzLjIgOS4zNDQgMjQxLjA4OCA5LjM0NCAyNDEuMDg4YTI4NS4zMTIgMjg1LjMxMiAwIDAgMSA1NS43NDQgODkuNiAxNTQuNCAxNTQuNCAwIDAgMSA5LjI4IDE0Mi40OTZzLTMuMi02Ni41Ni0xMDIuNC04MC4zNTJjLTkwLjkxMi0xMi44LTEyMy45NjggNzUuNzEyLTI5Ny42IDcxLjQyNEE1ODkuOTIgNTg5LjkyIDAgMCAxIDY0IDYxOS4zOTJjODQuODMyIDQ2LjI3MiAxOTUuOTY4IDExOC4wOCAzMzQuMzY4IDEwNy4wNzIgMTM4LjQtMTEuMDQgMTY3LjI5Ni01My41NjggMTY3LjI5Ni01My41NjhBMjE0MC43NjggMjE0MC43NjggMCAwIDEgMTU2LjUxMiAyNDQuNjRjMTA4LjggOTEuMDQgMzc4LjMwNCAyNzIuMjI0IDM3Mi4wMzIgMjY3LjYxNmEyNDI2LjQgMjQyNi40IDAgMCAxLTI2OS42LTMxMi41MTJTNjYzLjI5NiA1MzIuMTYgNjk1Ljg0IDUzMC4wOGMxMy4zNzYtMjcuNTUyIDgyLjUyOC0xNzAuMTc2LTc0LjM2OC00MDEuODI0aDAuMDMyeiIgZmlsbD0iI0Y4ODUzNSI+PC9wYXRoPjwvc3ZnPg==) 
 **/
export default function FoxIconSwift(_ref) {
  var size = _ref.size,
    color = _ref.color,
    style = _ref.style,
    className = _ref.className,
    spin = _ref.spin,
    rotate = _ref.rotate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var svgStyle = React.useMemo(function () {
    return rotate ? {
      msTransform: "rotate(".concat(String(rotate), "deg)"),
      transform: "rotate(".concat(String(rotate), "deg)")
    } : undefined;
  }, [rotate]);
  var customStyle = React.useMemo(function () {
    var tmp = {};
    if (size !== undefined) {
      tmp.fontSize = size;
    }
    if (color !== undefined) {
      tmp.color = color;
    }
    return tmp;
  }, [size, color, rotate]);
  var realStyle = React.useMemo(function () {
    if (style) {
      return _objectSpread(_objectSpread({}, customStyle), style);
    }
    return customStyle;
  }, [style, customStyle]);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    role: "img",
    className: classNames("appicon app_icon", className, spin ? "appicon-spin" : ""),
    style: realStyle
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Memo, {
      style: svgStyle
    })
  }));
}